// Productions Getters

export const getProductionsList = state => {
  return state.productionsList
}

export const getProductionInfo = state => {
  return state.productionInfo
}

export const getUnClosedProductionsCount = state => {
  return state.unclosedProductionsCount
}

export const getShiftTimes = state => {
  return state.shiftTimes
}
